import _classCallCheck from "D:\\Smartinspect\\react\\smartinspection.ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "D:\\Smartinspect\\react\\smartinspection.ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Smartinspect\\react\\smartinspection.ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Smartinspect\\react\\smartinspection.ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { ValueWithRandom } from "tsparticles-engine";
export var SplitFactor = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(SplitFactor, _ValueWithRandom);
  function SplitFactor() {
    var _this;
    _classCallCheck(this, SplitFactor);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(SplitFactor).call(this));
    _this.value = 3;
    return _this;
  }
  return SplitFactor;
}(ValueWithRandom);